import { render, staticRenderFns } from "./BolPage.vue?vue&type=template&id=b3069b06&scoped=true"
import script from "./BolPage.vue?vue&type=script&lang=js"
export * from "./BolPage.vue?vue&type=script&lang=js"
import style0 from "./BolPage.vue?vue&type=style&index=0&id=b3069b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3069b06",
  null
  
)

export default component.exports